var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForgotbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 733,
    viewBox: "0 0 375 733",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M356.764 474.898C220.266 489.811 -32.4294 571.196 48.765 777.429C150.258 1035.22 480.418 1378.07 110.808 1799.89",
    stroke: "url(#paint0_linear_59_2430)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M385.65 467.931C249.153 482.845 -3.54269 564.229 77.6517 770.462C179.145 1028.25 509.305 1371.11 139.695 1792.92",
    stroke: "url(#paint1_linear_59_2430)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M414.537 460.965C278.04 475.878 25.344 557.263 106.538 763.495C208.031 1021.29 538.191 1364.14 168.582 1785.96",
    stroke: "url(#paint2_linear_59_2430)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M443.426 453.998C306.928 468.912 54.2327 550.296 135.427 756.529C236.92 1014.32 567.08 1357.17 197.471 1778.99",
    stroke: "url(#paint3_linear_59_2430)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M472.31 447.032C335.813 461.945 83.1175 543.33 164.312 749.563C265.805 1007.35 595.965 1350.21 226.355 1772.03",
    stroke: "url(#paint4_linear_59_2430)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M501.197 440.065C364.7 454.978 112.004 536.363 193.199 742.596C294.692 1000.39 624.852 1343.24 255.242 1765.06",
    stroke: "url(#paint5_linear_59_2430)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.084 433.098C393.587 448.012 140.891 529.396 222.085 735.629C323.578 993.42 653.738 1336.27 284.129 1758.09",
    stroke: "url(#paint6_linear_59_2430)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M558.973 426.132C422.475 441.045 169.78 522.43 250.974 728.663C352.467 986.454 682.627 1329.31 313.017 1751.13",
    stroke: "url(#paint7_linear_59_2430)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M587.859 419.165C451.362 434.079 198.666 515.463 279.861 721.696C381.354 979.487 711.514 1322.34 341.904 1744.16",
    stroke: "url(#paint8_linear_59_2430)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M616.746 412.199C480.249 427.112 227.553 508.497 308.747 714.729C410.24 972.52 740.4 1315.37 370.791 1737.19",
    stroke: "url(#paint9_linear_59_2430)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M645.633 405.232C509.136 420.145 256.44 501.53 337.634 707.763C439.127 965.554 769.287 1308.41 399.678 1730.23",
    stroke: "url(#paint10_linear_59_2430)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M674.519 398.265C538.022 413.179 285.326 494.563 366.521 700.796C468.014 958.587 798.174 1301.44 428.564 1723.26",
    stroke: "url(#paint11_linear_59_2430)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M703.406 391.299C566.909 406.212 314.213 487.597 395.408 693.829C496.9 951.62 827.061 1294.47 457.451 1716.29",
    stroke: "url(#paint12_linear_59_2430)",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_2430",
    x1: 546.776,
    y1: 1548.18,
    x2: 9.57136,
    y2: 617.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_2430",
    x1: 575.663,
    y1: 1541.22,
    x2: 38.4581,
    y2: 610.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_2430",
    x1: 604.55,
    y1: 1534.25,
    x2: 67.3448,
    y2: 603.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_59_2430",
    x1: 633.439,
    y1: 1527.29,
    x2: 96.2335,
    y2: 596.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_59_2430",
    x1: 662.323,
    y1: 1520.32,
    x2: 125.118,
    y2: 589.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_59_2430",
    x1: 691.21,
    y1: 1513.35,
    x2: 154.005,
    y2: 582.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_59_2430",
    x1: 720.097,
    y1: 1506.39,
    x2: 182.892,
    y2: 575.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_59_2430",
    x1: 748.985,
    y1: 1499.42,
    x2: 211.78,
    y2: 568.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_59_2430",
    x1: 777.872,
    y1: 1492.45,
    x2: 240.667,
    y2: 561.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_59_2430",
    x1: 806.759,
    y1: 1485.49,
    x2: 269.554,
    y2: 555.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_59_2430",
    x1: 835.646,
    y1: 1478.52,
    x2: 298.441,
    y2: 548.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_59_2430",
    x1: 864.532,
    y1: 1471.55,
    x2: 327.327,
    y2: 541.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_59_2430",
    x1: 893.419,
    y1: 1464.59,
    x2: 356.214,
    y2: 534.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2E780"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC7DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotbg);
export default __webpack_public_path__ + "static/media/forgotbg.e59a3860356437837d04ff997df97dd7.svg";
export { ForwardRef as ReactComponent };